import dispatch from './dispatch';

export default [
  dispatch
];
